<template>
    <model-viewer 
        ref="modalViewer"
        bounds="tight" 
        :src="src" ar
        ar-modes="webxr scene-viewer quick-look"
        camera-controls 
        poster="poster.png" 
        :shadow-intensity="parseFloat(shadow_intensity)"
        :shadow-softness="parseFloat(shadow_softness)"
        autoplay 
        :environment-image="environment" 
        :animation-name="animation"
        :exposure="exposure == 0 ? 1 :exposure "
      >

    <div class="progress-bar hide" slot="progress-bar">
        <div class="update-bar"></div>
    </div>

</model-viewer>

</template>

<script>
export default {
    props : { 
        src : { type : String, default: null},
        camera : { type : String, default: null},
        animation : { type : String, default: 'Idle'},
        environment : { type : String, default: 'neutral'},
        shadow_intensity : { type : Number | String, default: 1},
        shadow_softness : { type : Number | String, default: 1},
        exposure : { type : Number | String, default: 1},
        factor : { type : String, default: null},
        modal_material : { type : String, default: null},
        texture : { type : String, default: null},
        form : { type : Object, default: null},
        

        
        
    },
    data(){
        return {
            factorColor : {r:0, g:0 ,b:0, a:1},
            modalViwer : null,
            material : null,
            selectedMaterialIndex : 0,
        }
    },
    mounted(){
        this.modalViwer = this.$refs.modalViewer
        this.modalViwer.addEventListener('load',(e)=>{
            this.material= this.modalViwer.model.materials
            this.$emit('getMaterial',this.material)
            this.selectedMaterialIndex = this.material.findIndex(item => item.name == this.modal_material)
            if(this.selectedMaterialIndex == -1) this.selectedMaterialIndex = 0
        })
    },
    computed : {
        color(){return this.factorColor}
    },
    watch : { 
        modal_material(value){
            this.selectedMaterialIndex = this.material.findIndex(item => item.name == value)
            if(this.selectedMaterialIndex == -1) this.selectedMaterialIndex = 0
              if(this.material[this.selectedMaterialIndex].pbrMetallicRoughness.baseColorFactor) {
                let element = this.material[this.selectedMaterialIndex].pbrMetallicRoughness.baseColorFactor
                let baseColor = this.rgbToHex(parseInt(element[0] * 255),parseInt(element[1] * 255),parseInt(element[2] * 255))
                let baseTexture = this.material[this.selectedMaterialIndex].pbrMetallicRoughness.baseColorTexture.texture
                // if(baseTexture) this.form.texture = baseTexture.source.uri
                // else this.form.texture = null
                // this.form.factor = baseColor
            console.log("vali index",this.selectedMaterialIndex);
            }
        },
        texture(value){
            this.createAndApplyTexture('baseColorTexture',value)
        },
        factor(value){ 
            console.log("vali factore",this.selectedMaterialIndex);
            this.factorColor = this.hexToRgbA(value)
            const {r,g,b,a} =  this.factorColor
            if(this.selectedMaterialIndex !=-1) this.material[this.selectedMaterialIndex].pbrMetallicRoughness.setBaseColorFactor([r/255,g/255,b/255,a]);
            else this.material[0].pbrMetallicRoughness.setBaseColorFactor([r/255,g/255,b/255,a]);
        }
    },
    methods : {
        rgbToHex(r, g, b) {
            return "#" + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
        },
     hexToRgbA(hex){
        var c;
        if(/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)){
            c= hex.substring(1).split('');
            if(c.length== 3){
                c= [c[0], c[0], c[1], c[1], c[2], c[2]];
            }
            c= '0x'+c.join('');
            let rgba = {
                r : (c>>16)&255,
                g : (c>>8)&255,
                b : c&255,
                a  : 1
            }
            return rgba
            // return 'rgba{'+[(c>>16)&255, (c>>8)&255, c&255].join(',')+',1)';
        }
        throw new Error('Bad Hex');
    },
    rgba2hex(rgba) {
        rgba = rgba.match(
            /^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?/i
        );
        return rgba && rgba.length === 4
            ? "#" +
                ("0" + parseInt(rgba[1], 10).toString(16)).slice(-2) +
                ("0" + parseInt(rgba[2], 10).toString(16)).slice(-2) +
                ("0" + parseInt(rgba[3], 10).toString(16)).slice(-2)
            : "";
    },
    async createAndApplyTexture (channel, value)  {
        let texture = value ? await this.modalViwer.createTexture(value) : undefined;
        if (channel.includes('base') || channel.includes('metallic')) {
        this.material[this.selectedMaterialIndex].pbrMetallicRoughness[channel].setTexture(texture);
        } else {
        this.material[this.selectedMaterialIndex][channel].setTexture(texture);
        }
    }
    }

}
</script>

<style lang="scss" scoped>
    model-viewer {
        width : 100%;
        height : 100%;
    }

</style>


// WEBPACK FOOTER //
// src/components/global/viewer.vue